module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_item_message":{"none":"No products available.","filtered":"No products match the criteria."}}}')
  delete Component.options._Ctor
}
